// removed by extract-text-webpack-plugin
module.exports = {"RecallDetail":"RecallDetail__RecallDetail___2ljZh","RecallDetailHeading":"RecallDetail__RecallDetailHeading___2p01Z","WithoutPadding":"RecallDetail__WithoutPadding___4vX6e","RecallDetailHeadingSection":"RecallDetail__RecallDetailHeadingSection___1ykZE","RecallDetailHeadingLabel":"RecallDetail__RecallDetailHeadingLabel___HjXID","RecallDetailStatus":"RecallDetail__RecallDetailStatus___nV4BM","RecallDetailStatusAmber":"RecallDetail__RecallDetailStatusAmber___1J0FX","RecallDetailStatusRed":"RecallDetail__RecallDetailStatusRed___1fDzf"};


//////////////////
// WEBPACK FOOTER
// ./src/AtomicContainers/RecallDetail/RecallDetail.less
// module id = 1199
// module chunks = 0 1